import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { BankAccount } from '../../../../banking/models/bank-account';

@Component({
  selector: 'app-vb-payment-change-submission-deposit-details-card',
  templateUrl: './vb-payment-change-submission-deposit-details-card.component.html',
  styleUrls: ['./vb-payment-change-submission-deposit-details-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeSubmissionDepositDetailsCardComponent implements OnChanges {
  @Input({ required: true }) currentBankAccount!: BankAccount | null;
  @Input({ required: true }) newBankAccount!: BankAccount | null;

  public hasChanges = false;

  public ngOnChanges(): void {
    this.hasChanges = (this.currentBankAccount?.id ?? null) !== (this.newBankAccount?.id ?? null);
  }
}
